import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '../main.styl';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light:{
                primary: '#2E4D5F',
                secondary: '#eceff1',
                accent: '#607D8B',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                topbar: '#E46D3F',
            },
            dark:{
                primary: '#2E4D5F',
                secondary: '#eceff1',
                accent: '#607D8B',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                topbar: '#E46D3F',
            }
        }
     },
});
